export const isServerSide = () => {
    return typeof window === 'undefined';
};

export const isClientSide = () => {
    return !isServerSide();
};
